export default (className = "topnav-mobile__meatball") => `
<svg class="${className}" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="22" height="24" viewBox="0 0 6 24"><path d="M0,3a3,3 0 1,0 6,0a3,3 0 1,0 -6,0" fill="#ffffff"/><path d="M0,12a3,3 0 1,0 6,0a3,3 0 1,0 -6,0" fill="#ffffff"/><path d="M0,21a3,3 0 1,0 6,0a3,3 0 1,0 -6,0" fill="#ffffff"/></svg>
`
